import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const TitleManager = () => {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname.toLowerCase();

        const staticTitles = {
            "/": "Gws Shopsy - Online Shopping Portal | Shop Online",
            "/cart": "Cart - gws shopsy",
            "/about-us/": "About Us - gws shopsy",
            "/contact-us/": "Contact Us - gws shopsy",
            "/wishlist": "Your Wishlist - gws shopsy",
            "/checkout": "Checkout - gws shopsy",
            "/profile": "Your Profile - gws shopsy",
            "/my-account/": "Login - gws shopsy",
            "/register": "Register - gws shopsy",
            "/return-policy/": "Return Policy - gws shopsy",
            "/delivery-information/": "Delivery Info - gws shopsy",
            "/shipping-policy/": "Shipping Policy - gws shopsy",
            "/pricing-and-payments-policy/": "Pricing & Payment Policy - gws shopsy",
            "/disclaimer-policy/": "Disclaimer Policy - gws shopsy",
            "/prebooking-terms-and-conditions/": "Prebooking Terms - gws shopsy",
            "/refund-return/": "Refund & Return - gws shopsy",
            "/terms-of-service/": "Terms of Service - gws shopsy",
            "/privacy-policy": "Privacy Policy - gws shopsy",
            "/faq/": "FAQs - gws shopsy",
            "/how-to/": "How to Use - gws shopsy",
            "/track-your-order/": "Track Order - gws shopsy",
            "/thankyoupage": "Thank You - gws shopsy",
            "/topselldetails": "Top Selling Products - gws shopsy",
            "/all-cate": "All Categories - gws shopsy",
            "/allproductdata": "All Products - gws shopsy",
            "/orderplace": "Order Placed - gws shopsy",
            "/showsubcategorydata": "Sub Category - gws shopsy",
            "/subcategorydata": "Sub Category - gws shopsy",
            "/shop": "Product Details - gws shopsy",
            "/coupons": "Coupons - gws shopsy",
        };

        let title = staticTitles[path] || "gws shopsy | Bharat's Shopping Portal";

        if (path.startsWith("/product-category/")) {
            const parts = path.split("/");
            const categoryName = parts[2]?.replace(/-/g, " ");
            if (categoryName) {
                title = `Buy ${decodeURIComponent(categoryName)} - From gws shopsy`;
            }
        }

        if (path.startsWith("/showsubcategory/")) {
            const parts = path.split("/");
            const subCategoryName = parts[2]?.replace(/-/g, " ");
            if (subCategoryName) {
                title = `Buy ${decodeURIComponent(subCategoryName)} - From gws shopsy`;
            }
        }

        if (path.startsWith("/product/")) {
            const slug = path.split("/")[2]?.replace(/-/g, " ");
            if (slug) {
                title = `Buy ${decodeURIComponent(slug)} - gws shopsy Online Shopping Cash On Delivery`;
            }
        }

        if (path.startsWith("/category/")) {
            const parts = path.split("/");
            const categoryTitle = parts[3]?.replace(/-/g, " ");
            if (categoryTitle) {
                title = `Buy ${decodeURIComponent(categoryTitle)} - gws shopsy Online Shopping Cash On Delivery`;
            }
        }

        if (path.startsWith("/shop/")) {
            const parts = path.split("/");
            const rawTitle = parts[parts.length - 1];
            const formattedTitle = rawTitle.replace(/-/g, " ");
            title = `Buy ${decodeURIComponent(formattedTitle)} - gws shopsy Online Shopping Cash On Delivery`;
        }
        document.title = title;
    }, [location]);
    return null;
};

export default TitleManager;
